var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#133D61",
    d: "m17.678 14.143-.015.013.55.55L4.07 28.85.535 25.314 11.156 14.69 0 3.535 3.535 0z"
  })));
};
export { SvgChevronRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAxOSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjY3NzcgMTQuMTQyNkwxNy42NjMxIDE0LjE1NjJMMTguMjEyOSAxNC43MDYxTDQuMDcwMzEgMjguODQ4NkwwLjUzNTE1NiAyNS4zMTM1TDExLjE1NjIgMTQuNjkxNEwwIDMuNTM1MTZMMy41MzUxNiAwTDE3LjY3NzcgMTQuMTQyNloiIGZpbGw9IiMxMzNENjEiLz4KPC9zdmc+Cg==";